"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_PRODUCT_AGGREGATED_ATTRIBUTE_VALUES_PAGINATION = void 0;
const gql_1 = require("../../../../__generated__/gql");
exports.GET_PRODUCT_AGGREGATED_ATTRIBUTE_VALUES_PAGINATION = (0, gql_1.gql)(`
  query ProductAggregatedAttributeValuesPagination(
    $ids: [ID!],
    $productTreeId: ID!,
    $attribute: String,
    $first: Int,
    $productTreeNodeIds: [ID!]
  ) {
    catalogs(ids: $ids) {
      edges {
        node {
          id
          statistics(productTreeNodeIds: $productTreeNodeIds, productTreeId: $productTreeId) {
            attributes(attribute: $attribute, first: $first) {
              edges {
                node {
                  dimensions {
                    productTreeNode {
                      id
                      title
                    }
                    attribute
                    value
                  }
                  applied
                }
              }
              totalCount
              pageInfo {
                endCursor
                hasNextPage
                hasPreviousPage
                startCursor
              }
            }
          }
        }
      }
    }
  }
`);
